import * as React from "react";
import { EditableDropdown } from "azure-devops-ui/EditableDropdown";
import { editableDropdownItems } from "./Data";
import { IListBoxItem } from "azure-devops-ui/ListBox";
import { Observer } from "azure-devops-ui/Observer";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class DropdownMultiSelectExample extends React.Component {
    private selectedItem = new ObservableValue<string>("");

    public render() {
        return (
            <div className="flex-row" style={{ margin: "8px", alignItems: "center" }}>
                <EditableDropdown
                    items={editableDropdownItems}
                    onValueChange={this.onValueChange}
                    placeholder="Select an Option"
                />
                <Observer selectedItem={this.selectedItem}>
                    {(props: { selectedItem: string }) => {
                        return (
                            <span style={{ marginLeft: "8px", width: "150px" }}>
                                Selected Item: {props.selectedItem}{" "}
                            </span>
                        );
                    }}
                </Observer>
            </div>
        );
    }

    private onValueChange = (value?: IListBoxItem<{}>) => {
        this.selectedItem.value = (value && value.text) || "";
    };
}
